var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 37,
    viewBox: "0 0 28 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6328 17.5748C12.3541 17.5748 11.1277 17.0875 10.2235 16.2202C9.31935 15.3528 8.81138 14.1764 8.81138 12.9498C8.81138 11.7232 9.31935 10.5468 10.2235 9.67945C11.1277 8.81209 12.3541 8.32482 13.6328 8.32482C14.9115 8.32482 16.1379 8.81209 17.0421 9.67945C17.9463 10.5468 18.4542 11.7232 18.4542 12.9498C18.4542 13.5572 18.3295 14.1586 18.0872 14.7197C17.8449 15.2809 17.4898 15.7907 17.0421 16.2202C16.5944 16.6497 16.0629 16.9903 15.4779 17.2228C14.8929 17.4552 14.266 17.5748 13.6328 17.5748ZM13.6328 -0.000183105C10.0524 -0.000183105 6.61861 1.36419 4.08687 3.79278C1.55513 6.22138 0.132813 9.51526 0.132812 12.9498C0.132813 22.6623 13.6328 36.9998 13.6328 36.9998C13.6328 36.9998 27.1328 22.6623 27.1328 12.9498C27.1328 9.51526 25.7105 6.22138 23.1788 3.79278C20.647 1.36419 17.2132 -0.000183105 13.6328 -0.000183105Z",
    fill: "url(#paint0_linear_179_10582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_10582",
    x1: 11.2221,
    y1: 36.9998,
    x2: 13.6328,
    y2: 36.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#7A766D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#918F89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/Default.c68970e461778ed4d93f46e3758d4c4a.svg";
export { ForwardRef as ReactComponent };